import { SubmissionError } from 'redux-form'
import validator from 'validator';
import {translate} from "../../../translations/i18n";

const createValidationError = (field) => {
  return new SubmissionError({
    ...field,
    _error: "Cannot send an article"
  });
}

const validateSettingsField = (values) => {

  validateTitle(values);
  validateOGImage(values);
  validateCustomDomain(values);

};

const validateTitle = (values) => {
  const { title } = values;
  if (!title) {
    throw createValidationError({ title: translate('settings.form_title.errors.cannot_be_empty') });
  } else if(title.length < 2) {
    throw createValidationError({ title: translate('settings.form_title.errors.must_be_longer') });
  } else if (title.length > 120) {
    throw createValidationError({ title: translate('settings.form_title.errors.must_be_shorter') });
  }
}

const validateOGImage = (values) => {

  const { opengraph_default_image_url } = values;

  if (opengraph_default_image_url && !validator.isURL(opengraph_default_image_url)) {
    throw createValidationError({ opengraph_default_image_url: translate('settings.seo.form_default_image.errors.invalid') });
  }
}

const validateCustomDomain = (values) => {
  const { custom_domain } = values;

  if (!custom_domain) {
    return;
  }

  if(custom_domain.startsWith('http://') || custom_domain.startsWith('https://')) {
    throw createValidationError({custom_domain: translate('settings.form_custom_domain.errors.no_protocol')});
  }

  if(custom_domain.startsWith('www.')) {
    throw createValidationError({custom_domain: translate('settings.form_custom_domain.errors.no_www')});
  }

  if(!validator.isURL(custom_domain)) {
    throw createValidationError({custom_domain: translate('settings.form_custom_domain.errors.invalid')});
  }

}

export default validateSettingsField;
